import pluralize from "pluralize";
import {Link} from "react-router";

import {shortCurrency} from "@/lib/format.tsx";
import {ServiceUsage} from "@/lib/types/checks.ts";

interface YouReachedMaximumProps {
  serviceUsage: ServiceUsage;
  userCanPurchase: boolean;
}

export const YouReachedMaximum = ({serviceUsage, userCanPurchase}: YouReachedMaximumProps) => (
  <small>
    <p>
      You have reached the maximum number of <strong>{serviceUsage.limit_name}</strong> Checks available in your
      account.
      <br />
      {`Would you like to ${userCanPurchase ? "purchase" : "request purchase"} an additional 
      ${serviceUsage.bundle_size} ${pluralize("check", serviceUsage.bundle_size)} now for 
      ${shortCurrency(serviceUsage.bundle_price, 2)}?`}
    </p>
    {userCanPurchase ? (
      <p>This purchase will use your saved billing information that is configured on your account.</p>
    ) : (
      <p>
        The purchase <strong>request</strong> will be sent to the <strong>owner of this account</strong>. Once it is
        purchased, the requested Checks will be added to the account.
      </p>
    )}
    <p>
      If you have any questions don’t hesitate to <Link to="/contact">contact us</Link>.
    </p>
  </small>
);
